import { ChipProps } from '@mui/material';
import { useGetAreasOfLearningQuery } from '@schooly/api';
import { Spin } from '@schooly/style';
import { TagSelect } from '@schooly/style';
import { useMemo } from 'react';
import { FC } from 'react';

export type AreaOfLearningTagSelectProps = {
  id: string;
  schoolId: string;
} & Omit<ChipProps, 'label'>;

export const AreaOfLearningTagSelect: FC<AreaOfLearningTagSelectProps> = ({
  id,
  schoolId,
  ...props
}) => {
  const { data } = useGetAreasOfLearningQuery(schoolId, { enabled: !!schoolId });

  const name = useMemo(() => data?.find((a) => a.id === id)?.name, [data, id]);

  return <TagSelect label={name ?? <Spin />} {...props} />;
};
